/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Label_Salary_MaxInputs */

const en_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Max`)
};

const de_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehalt Max`)
};

const fr_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salaire max`)
};

const es_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salario máx.`)
};

const it_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stipendio max`)
};

const nl_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salaris max`)
};

const pl_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynagrodzenie max`)
};

const fi_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkka max`)
};

const da_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Løn maks`)
};

const sv_jobs_search_criteria_label_salary_max = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lön max`)
};

/**
* | output |
* | --- |
* | "Salary Max" |
*
* @param {Jobs_Search_Criteria_Label_Salary_MaxInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_label_salary_max = /** @type {((inputs?: Jobs_Search_Criteria_Label_Salary_MaxInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Label_Salary_MaxInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "es") return es_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "it") return it_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "da") return da_jobs_search_criteria_label_salary_max(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_label_salary_max(inputs)
	return en_jobs_search_criteria_label_salary_max(inputs)
});